import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import CrossIcon from "../../../icons/cross.icon";
import SuccessSignIcon from "../../../icons/success-sign.icon";
import useDropdown from "../../../../hooks/dropdown.hook";
import styles from "./distributor-filter-dropdown.module.scss";

export const DistributorFilterDropdown = () => {
  const [selectedDistributor, setSelectedDistributor] =
    useState("Portland");
  const { isOpen, setIsOpen, refBtn, refMenu } = useDropdown({});

  const distributors = [
    {
      id: "highground",
      name: "HighGround",
      icon: <div className={styles.distributorIcon}>HG</div>,
    },
    {
      id: "portland",
      name: "Portland",
      icon: <div className={styles.distributorIcon}>HG</div>,
    },
    {
      id: "brigantia",
      name: "Brigantia",
      icon: <div className={styles.distributorIcon}>BR</div>,
    },
    {
      id: "virosafe",
      name: "Virosafe",
      icon: <div className={styles.distributorIcon}>VS</div>,
    },
  ];

  const handleRemoveDistributor = (e) => {
    e.stopPropagation();
    setSelectedDistributor("");
  };

  const handleDistributorClick = (id, name) => {
    setSelectedDistributor(name);
    setIsOpen(false);
  };

  return (
    <div className={styles.leftSection}>
      <Dropdown
        show={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
        className={styles.dropdown}
      >
        <Dropdown.Toggle ref={refBtn} className={styles.toggleButton}>
          <div className={styles.toggleButtonContent}>
            <div className={styles.toggleButtonText}>
              Filter by Distributor
            </div>
          </div>
          <div className={styles.toggleButtonIcon}>
            <img src="/images/big-chevron-down.svg" alt="" width="9px" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu ref={refMenu} className={styles.dropdownMenu} renderOnMount>
          <div className={styles.dropdownMenuContent}>
            <div className={styles.dropdownMenuHeader}>
              <div className={styles.dropdownMenuLabel} id="distributors-label">
                Distributors
              </div>
            </div>
            {distributors.map((distributor) => (
              <Dropdown.Item
                key={distributor.id}
                className={styles.dropdownMenuItem}
                onClick={() => handleDistributorClick(distributor.id, distributor.name)}
                role="option"
                aria-selected={selectedDistributor === distributor.name}
                tabIndex={0}
              >
                <div className={styles.dropdownMenuItemContent}>
                  <div className={styles.checkIconWrapper}>
                    {selectedDistributor === distributor.name && (
                      <SuccessSignIcon 
                        width={16} 
                        height={12} 
                        fill="#616778" 
                        className={styles.checkIcon}
                      />
                    )}
                  </div>
                  <div className={styles.dropdownMenuItemIcon}>
                    {distributor.icon}
                  </div>
                  <div className={styles.dropdownMenuItemText}>
                    {distributor.name}
                  </div>
                </div>
              </Dropdown.Item>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>

      {selectedDistributor && (
        <div className={styles.selectedBadge}>
          <div className={styles.selectedBadgeContent}>
            <div className={styles.selectedBadgeText}>
              Distributor: {selectedDistributor}
            </div>
          </div>
          <button
            className={styles.removeButton}
            onClick={handleRemoveDistributor}
            aria-label={`Remove ${selectedDistributor} distributor filter`}
          >
            <div className={styles.removeButtonIcon}>
              <div className={styles.removeButtonIconInner}>
                <CrossIcon className={styles.closeIcon} width="9px" height="9px" fill="white" />
              </div>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

